module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-builder-controls-container">\n	<div class="team-builder-controls-left auto-width">\n		';
 if(team_is_began_to_score || is_history_mode){ 
__p+='\n			';
 if(is_coach_enabled){ 
__p+='\n				<div class="team-value-info coach-stats">\n					<h5 class="team-info-title">Proj Score</h5>\n					<span class="team-info-value">\n						';
 if(has_assistant_coach){ 
__p+='\n							'+
((__t=( team_proj_score ))==null?'':_.escape(__t))+
'\n						';
 } else { 
__p+='\n							<!-- User has no assistant coach but trigger to show coach data -->\n							<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n						';
 } 
__p+='\n					</span>\n				</div>\n			';
 } else { 
__p+='\n				<div class="round-score">\n					<h5 class="team-info-title">Round '+
((__t=( history_round_id || actual_round_id ))==null?'':_.escape(__t))+
' Score</h5>\n					<span class="team-info-value '+
((__t=( is_somebody_playing ? 'is-playing-now' : '' ))==null?'':_.escape(__t))+
'">\n						'+
((__t=( is_somebody_playing ? team_score : (_.result(scoreflow, (history_round_id || actual_round_id), team_score) || '-') ))==null?'':_.escape(__t))+
'\n					</span>\n				</div>\n			';
 } 
__p+='\n\n			<div class="">\n				<h5 class="team-info-title">Overall Score</h5>\n				<span class="team-info-value">'+
((__t=( overall_score ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="column-height">\n				<h5 class="team-info-title">Overall Rank</h5>\n				<div class="team-info-value">\n					';
 if (is_history_mode) { 
__p+='\n						'+
((__t=( _.result(rank_history, history_round_id, '-') ))==null?'':_.escape(__t))+
'\n					';
} else {
__p+='\n						<div class="upper-value">\n							'+
((__t=( rank ))==null?'':_.escape(__t))+
'\n						</div>\n						<div class="lower-value hidden-mobile">\n							/'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'\n						</div>\n\n					';
} 
__p+='\n\n				</div>\n			</div>\n\n			<div class="column-height hidden-mobile">\n				<h5 class="team-info-title">Round '+
((__t=( history_round_id || actual_round_id ))==null?'':_.escape(__t))+
' Rank</h5>\n				<div class="team-info-value">\n					<div class="upper-value">\n						'+
((__t=( _.result(obj.round_rank_history, history_round_id, round_rank) ))==null?'':_.escape(__t))+
'\n					</div>\n\n					';
 if(!is_history_mode){ 
__p+='\n\n					<div class="lower-value">\n						/'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'\n					</div>\n\n					';
 } 
__p+='\n				</div>\n			</div>\n\n			';
 if(!is_history_mode){ 
__p+='\n				<div class="trades-info ">\n					<h5 class="team-info-title">Trades remaining</h5>\n					<span class="team-info-value">\n						';
 if(is_unlimited_trades){ 
__p+='\n						UNL\n						';
 } else { 
__p+='\n							'+
((__t=( _.result(team, 'season_trades_left', '-') ))==null?'':_.escape(__t))+
'('+
((__t=( _.result(team, 'week_trades_left', '-') ))==null?'':_.escape(__t))+
')\n						';
 } 
__p+='\n					</span>\n				</div>\n				<div class="salary-cap-info">\n					<h5 class="team-info-title">Salary Remaining</h5>\n					<span class="team-info-value '+
((__t=( remaining_salary < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n						'+
((__t=( _.currencyFormat(remaining_salary, '$', true) ))==null?'':_.escape(__t))+
'\n					</span>\n				</div>\n			';
 } 
__p+='\n\n		';
 } else { 
__p+='\n			<div class="trades-info ">\n				<h5 class="team-info-title">Trades remaining</h5>\n				<span class="team-info-value">\n					';
 if(is_unlimited_trades){ 
__p+='\n						UNL\n					';
 } else { 
__p+='\n						'+
((__t=( _.result(team, 'season_trades_left', '-') ))==null?'':_.escape(__t))+
'('+
((__t=( _.result(team, 'week_trades_left', '-') ))==null?'':_.escape(__t))+
')\n					';
 } 
__p+='\n				</span>\n			</div>\n			<div class="salary-cap-info ">\n				<h5 class="team-info-title">Salary Remaining</h5>\n				<span class="team-info-value '+
((__t=( remaining_salary < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( _.currencyFormat(remaining_salary, '$', true) ))==null?'':_.escape(__t))+
'\n				</span>\n			</div>\n			';
 if(is_coach_enabled){ 
__p+='\n				<div class="team-value-info coach-stats hidden-mobile">\n					<h5 class="team-info-title">Proj Score</h5>\n					<span class="team-info-value">\n						';
 if(has_assistant_coach){ 
__p+='\n							'+
((__t=( team_proj_score ))==null?'':_.escape(__t))+
'\n						';
 } else { 
__p+='\n							<!-- User has no assistant coach but trigger to show coach data -->\n							<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n						';
 } 
__p+='\n					</span>\n				</div>\n			';
 } else { 
__p+='\n				<div class="team-value-info hidden-mobile">\n					<h5 class="team-info-title">Team Value</h5>\n					<span class="team-info-value">\n						'+
((__t=( _.currencyFormat(team_value) ))==null?'':_.escape(__t))+
'\n					</span>\n				</div>\n			';
 } 
__p+='\n		';
 } 
__p+='\n	</div>\n	<div class="team-builder-controls-center auto-width-desktop">\n		';
 if(!is_history_mode){ 
__p+='\n			';
 if(is_unlimited_trades){ 
__p+='\n				';
 if(team_has_players){ 
__p+='\n					<button class="js-clear btn-autofill">Clear</button>\n				';
 } 
__p+='\n				';
 if(!team_is_filled){ 
__p+='\n					<button class="js-autofill btn-autofill">Auto Fill</button>\n				';
 } 
__p+='\n			';
 } 
__p+='\n			<button class="js-save btn-save">Save</button>\n		';
 } 
__p+='\n	</div>\n	<div class="team-builder-controls-right auto-width">\n		';
 if(!is_mobile_view){ 
__p+='\n			<div class="team-field-next-lockout">\n				<h5>Next Lockout</h5>\n				<div class="js-team-field-next-lockout-timer next-lockout-timer" data-start-at="'+
((__t=( next_lockout ))==null?'':_.escape(__t))+
'"></div>\n			</div>\n			<div class="team-field-type-toggle">\n				<input '+
((__t=( !is_list_view ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						class="js-toggle-team-field"\n				       type="radio"\n				       name="team_view[]"\n						value="pitch"\n				       id="team_pitch_view">\n				<label for="team_pitch_view">Field</label>\n\n				<input '+
((__t=( is_list_view ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						class="js-toggle-team-field"\n				       type="radio"\n				       name="team_view[\'list\']"\n						value="list"\n				       id="team_list_view">\n				<label for="team_list_view">List</label>\n			</div>\n		';
 } 
__p+='\n		';
 if(!is_history_mode){ 
__p+='\n\n		<div class="fantasy-coach-stats-toggle">\n			<input '+
((__t=( is_coach_enabled ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n			       type="checkbox"\n			       name="coach_stats_toggle"\n			       id="coach_stats_toggle"\n			       class="js-toggle-fantasy-coach ios-switch">\n			<label for="coach_stats_toggle"></label>\n			<label for="coach_stats_toggle">Coach '+
((__t=( is_coach_enabled ? 'ON' : 'OFF' ))==null?'':_.escape(__t))+
'</label>\n		</div>\n		';
 } 
__p+='\n\n	</div>\n</div>';
}
return __p;
};
